import { IArticle } from '@models/IArticle';
import { IMeta } from '@models/IMeta';
import ArticleCard from '@molecules/ArticleCard/ArticleCard';

interface Props {
  readonly sectionTitle: string;
  readonly articles: IArticle[];
  readonly meta: IMeta;
  readonly anchorId: string;
}

const RelatedArticles = ({
  sectionTitle,
  articles = [],
  meta,
  anchorId = '',
}: Props) => (
  <section
    className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
    data-epi-block-id={meta?.contentLink}
    id={`a-${anchorId}`}
    data-testid="CT-34-Related-Articles"
  >
    <div className="container">
      <div className="flex flex-wrap gap-8 lg:gap-13">
        {sectionTitle && (
          <h2
            className="w-full"
            data-epi-property-name={meta?.editHints?.sectionTitle}
            data-testid="CT-34-Related-Articles-Title"
          >
            {sectionTitle}
          </h2>
        )}
        <div
          className="grid w-full grid-cols-1 gap-x-4 gap-y-12 lg:grid-cols-2 lg:gap-y-20 xl:grid-cols-3"
          data-epi-property-name={meta?.editHints?.articles}
        >
          {articles.length > 0 &&
            articles.map((article, index) => (
              <ArticleCard
                key={`Article-Card-${article.title}`}
                {...article}
                dataTestId={`CT-34-Related-Articles-Card-${index}`}
              />
            ))}
        </div>
      </div>
    </div>
  </section>
);

export default RelatedArticles;
